/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Pressemeddelelser - CamAPS FX',
    titleMeta: 'Pressemeddelelser - CamAPS FX',
    descriptionMeta: 'Seneste pressemeddelelser og nyheder fra CamAPS FX.',
    keywords: 'camaps pressemeddelelser, camaps nyheder, diabetes teknologi nyheder',
    localeMeta: 'da_dk',

    bannerTitle: 'Pressemeddelelser',
    bannerSubtitle: 'Hold dig opdateret med vores seneste meddelelser',

    contactText: 'For presseforespørgsler, kontakt venligst via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Alle pressemeddelelser udgives på engelsk.',

    download: 'Download',
    showMore: 'Vis mere',
    showLess: 'Vis mindre',
};

